/**
 * Base Component all Components should extend
 *
 * A component is a combination of a template, data, and presentation logic.
 * Abstract class that should be extended and not directly implemented.
 */
export default class Component {
    /**
     * @param Loader loader
     */
    constructor(loader) {
        this.loader = loader;
    }

    // abstract, must be implemented
    // HTML element ID containing the template content
    templateId() {
        throw new TypeError(this.constructor.name + ' must implement the `templateId` method');
    }

    // abstract, must be implemented
    // source of data for the loader
    // in the case of AJAX, it would be a URL, but the loader is not
    // necessarily an AJAX call so it may return anything, depending
    data() {
        throw new TypeError(this.constructor.name + ' must implement the `data` method');
    }

    // callback method to run on data returned from loader
    // used to manipulate loader data before passing to template
    // does not need to be implemented if no processing is required
    process() {
        return;
    }
}
